import { EasmFindingDetailsWebComponent } from '../component/EasmFindingDetailsWebComponent';
import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { EasmFindingDetailsView } from '../view/EasmFindingDetailsView';
import { templateEasmAssetDetailsPanel } from '../view/template';
import { EasmFindingDetailsRepository } from '../repository/EasmFindingDetailsRepository';
import { FindingType } from '../../types';
import { FindingDetailsPayload } from '../../findingDetails/findingDetails/types';

export class EasmFindingDetailsController extends BaseWebComponentController {
  public component: EasmFindingDetailsWebComponent;
  public view: EasmFindingDetailsView;
  public dataRepository: EasmFindingDetailsRepository;
  public dataRepositoryConstructor: typeof EasmFindingDetailsRepository;

  constructor(component: EasmFindingDetailsWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: EasmFindingDetailsView,
      viewTemplate: templateEasmAssetDetailsPanel,
      dataRepositoryConstructor: EasmFindingDetailsRepository,
    });
  }
  async getDataForView(): Promise<FindingDetailsPayload> {
    this.view.setLoadingState();
    const response = await this.dataRepository.getDetailsForFinding(this.component.findingId);
    this.view.removeLoadingState();
    if (response.type !== FindingType.SERVICE || !response.cves || response.cves.length === 0) {
      return response;
    }
    const cveResponse = await this.dataRepository.getCVEFromStandardIdsForCompany(response.companyId, response.cves);
    return {
      ...response,
      cvesDetailedList: cveResponse,
    };
  }
}
